import React from "react";
import BlueLayout from "../layouts/BlueLayout";
import "../hooks/useBreakpoints";
import Curve from "../components/global/Curve";

const ThePlatformScreen = () => {
  return (
    <>
      <BlueLayout>
        <div className="bg-night-blue">
          <div className="gap-9 grid xl:grid-cols-2 xl:gap-16 container">
            <div>
              <h1 className=" text-center text-creamy-beige font-light lg:mt-28 xl:text-left">
                CONNECTING THE
                <span className="font-semibold block text-canton-jadesheen">
                  {" "}
                  CLASSROOM TO <span className="xl:block">THE WORLD</span>
                </span>
              </h1>
              <p className="text-creamy-beige mt-8 text-center xl:text-left">
                We bring the cultural and natural diversity of the world
                directly into the classroom.
              </p>
            </div>
            <img
              src={require("../assets/images/the-plataform/bus.png")}
              alt=""
              className="lg:mt-28 xl:max-w-[534px] xl:ml-auto"
            />
          </div>
        </div>
        <Curve color="--var-color-vrc-creamy-beige" />
        <div className="bg-creamy-beige mt-[-2px]">
          <div className="container">
            <div className="flex flex-col place-items-center lg:grid lg:grid-cols-2 container-2 lg:mx-auto pb-24 lg:gap-10 xl:gap-0">
              <div style={{ paddingTop: "70px" }}>
                <h2 className="text-canton-jadesheen">
                  A NEW WAY OF TEACHING <p>HAS ARRIVED</p>
                </h2>
                <p className="py-8">
                  The VR Voyage Classroom works with cultural institutions,
                  environmental organizations, Indigenous communities, and
                  experts in science and the humanities, to create a hub for
                  teachers to bring their curriculum to life. No teacher can be
                  an expert in every curriculum theme. Our network of experts
                  helps classes learn directly from the source.
                </p>
              </div>
              <div className="mr-auto lg:row-start-1">
                <img
                  src={require("../assets/images/the-plataform/1.jpg")}
                  alt=""
                  className="xl:max-w-[400px]"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="flex flex-col place-items-center lg:grid lg:grid-cols-2 container-2 lg:mx-auto pb-24 lg:gap-10 xl:gap-0">
            <div>
              <h2 className="text-canton-jadesheen">
                A DIRECT LINK TO THE CURRICULUM
              </h2>
              <p className="py-8">
                Our education team connects every experience to the specific
                Prescribed Learning Outcomes outlined in the
                Provincial/Territorial curriculum guides. No more need for
                teachers to spend hours looking for the right resource, our team
                does the work and with a simple click of the curriculum the
                relevant information pops up.
              </p>
            </div>
            <div className="ml-auto">
              <img
                src={require("../assets/images/the-plataform/2.jpg")}
                alt=""
                className="xl:max-w-[400px]"
              />
            </div>
          </div>
        </div>

        <div className="container lg:pb-36">
          <div className="flex flex-col place-items-center lg:grid lg:grid-cols-2 container-2 lg:mx-auto pb-24 lg:gap-10 xl:gap-0">
            <div>
              <h2 className="text-canton-jadesheen">
                LIVE-STREAMED OR IN-PERSON
              </h2>
              <p className="py-8">
                No matter where the classroom is, the world is open to them. Our
                platform lists both in-person and online experiences to ensure
                students experience a well-rounded curriculum by being able to
                visit museums, aquariums, science centres, and heritage sites
                regardless of how close they are to their community.
              </p>
            </div>
            <div className="mr-auto lg:row-start-1">
              <img
                src={require("../assets/images/the-plataform/3.jpg")}
                alt=""
                className="xl:max-w-[400px]"
              />
            </div>
          </div>
        </div>
        <Curve color="--var-color-vrc-night-blue" />
      </BlueLayout>
    </>

    // old code
    // <>
    //   <Landing2
    //     bg="connecting"
    //     height="1080px"
    //     position="40%"
    //     horizontal="flex-start"
    //     vertical="center"
    //     heading="Connecting the Classroom to the World"
    //     hWidth="650px"
    //     copy="We bring the cultural and natural diversity of the world directly into the classroom."
    //     cWidth="800px"
    //     color="beige"
    //     cColor="beige"
    //     shadowColor="grey"
    //   />
    //   <div
    //     style={{
    //       backgroundImage: "url(./images/landing-generic.png)",
    //       backgroundRepeat: "norepeat",
    //       backgroundSize: "cover",
    //       height: "fit-content",
    //     }}
    //   >
    //     <Landing2
    //       bg="new-way2"
    //       position="25%"
    //       height="500px"
    //       horizontal="flex-end"
    //       vertical="center"
    //       heading="A New Way of Teaching Has Arrived"
    //       hWidth="550px"
    //       copy="The VR Voyage Classroom works with cultural institutions, environmental organizations, Indigenous communities, and experts in science and the humanities, to create a hub for teachers to bring their curriculum to life. No teacher can be an expert in every curriculum theme. Our network of experts helps classes learn directly from the source."
    //       cWidth="550px"
    //       color="red"
    //       cColor="grey"
    //     />
    //     <Landing2
    //       bg="direct"
    //       position="30%"
    //       height="500px"
    //       horizontal="flex-start"
    //       vertical="center"
    //       heading="A Direct Link to The Curriculum"
    //       hWidth="500px"
    //       copy="Our education team connects every experience to the specific Prescribed Learning Outcomes outlined in the Provincial/Territorial curriculum guides. No more need for teachers to spend hours looking for the right resource, our team does the work and with a simple click of the curriculum the relevant information pops up."
    //       cWidth="700px"
    //       color="beige"
    //       cColor="beige"
    //       shadowColor="grey"
    //     />
    //     <Landing2
    //       bg="live-streamed"
    //       position="25%"
    //       height="500px"
    //       horizontal="flex-end"
    //       vertical="center"
    //       heading="Live-streamed or In-person"
    //       hWidth="350px"
    //       copy="No matter where the classroom is, the world is open to them. Our platform lists both in-person and online experiences to ensure students experience a well-rounded curriculum by being able to visit museums, aquariums, science centres, and heritage sites regardless of how close they are to their community."
    //       cWidth="550px"
    //       color="red"
    //       cColor="beige"
    //       shadowColor="grey"
    //     />
    //   </div>
    // </>
  );
};

export default ThePlatformScreen;
